var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgInstagram = function SvgInstagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#instagram_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#instagram_svg__b)",
    d: "M24.5 0h-17A7.5 7.5 0 0 0 0 7.5v17A7.5 7.5 0 0 0 7.5 32h17a7.5 7.5 0 0 0 7.5-7.5v-17A7.5 7.5 0 0 0 24.5 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#instagram_svg__c)",
    d: "M24.5 0h-17A7.5 7.5 0 0 0 0 7.5v17A7.5 7.5 0 0 0 7.5 32h17a7.5 7.5 0 0 0 7.5-7.5v-17A7.5 7.5 0 0 0 24.5 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.001 3.5c-3.395 0-3.82.015-5.154.075-1.33.061-2.24.272-3.034.581A6.1 6.1 0 0 0 5.6 5.598a6.1 6.1 0 0 0-1.443 2.214c-.31.795-.52 1.703-.58 3.034-.06 1.333-.076 1.76-.076 5.154s.015 3.82.075 5.153c.062 1.33.272 2.24.581 3.034.32.822.747 1.52 1.442 2.214a6.1 6.1 0 0 0 2.214 1.443c.795.31 1.703.52 3.034.58 1.333.061 1.759.076 5.154.076s3.82-.015 5.153-.075c1.33-.061 2.24-.272 3.035-.581a6.1 6.1 0 0 0 2.213-1.443 6.1 6.1 0 0 0 1.443-2.214c.307-.795.518-1.704.58-3.034.06-1.333.076-1.758.076-5.153s-.016-3.82-.076-5.154c-.062-1.33-.273-2.24-.58-3.034A6.1 6.1 0 0 0 26.4 5.598a6.1 6.1 0 0 0-2.213-1.442c-.797-.309-1.706-.52-3.037-.58-1.333-.061-1.758-.076-5.154-.076zM14.88 5.753H16c3.338 0 3.733.012 5.051.071 1.219.056 1.88.26 2.321.431.583.226 1 .497 1.437.935s.708.854.935 1.437c.171.44.375 1.102.43 2.32.06 1.319.073 1.714.073 5.05s-.013 3.732-.073 5.05c-.055 1.218-.259 1.88-.43 2.32a3.9 3.9 0 0 1-.935 1.436 3.9 3.9 0 0 1-1.437.935c-.44.172-1.102.375-2.32.43-1.319.06-1.714.074-5.052.074s-3.733-.013-5.05-.073c-1.22-.056-1.881-.26-2.322-.431-.583-.227-1-.498-1.438-.935a3.9 3.9 0 0 1-.935-1.437c-.171-.44-.375-1.101-.43-2.32-.06-1.318-.072-1.714-.072-5.052s.012-3.732.072-5.05c.055-1.218.259-1.88.43-2.32.227-.584.498-1 .935-1.438a3.9 3.9 0 0 1 1.438-.935c.44-.172 1.102-.375 2.321-.431 1.153-.052 1.6-.068 3.93-.07zm7.794 2.075a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M16 9.581a6.42 6.42 0 1 0 .001 12.839 6.42 6.42 0 0 0-.001-12.84m0 2.252a4.167 4.167 0 1 1 0 8.334 4.167 4.167 0 0 1 0-8.334"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "instagram_svg__b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(0 -31.7144 29.4969 0 8.5 34.465)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF543E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C837AB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "instagram_svg__c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(2.78244 13.90076 -57.2994 11.46931 -5.36 2.305)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3771C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.128,
    stopColor: "#3771C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "instagram_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })))));
};
export default SvgInstagram;